import React, { useContext, useEffect, useState } from 'react'
import { RxCross2 } from "react-icons/rx";
import { LoadingFull } from '../../loading';
import { QRCodeCanvas } from "qrcode.react";
import { UserContext } from '../../../App';
import { v4 as uuidv4 } from "uuid";

export const ChooseImages = ({imageFiles, setImageFiles, images, setImages, error, setError, scrollTo}) => {
  
  const { socket } = useContext(UserContext)
  const [sessionId, setSessionId] = useState("");
  const imageTypeRegex = /image\/(png|jpg|jpeg)/gm;
  const delay = ms => new Promise(res => setTimeout(res, ms));
  const isMobile = window.innerWidth < 640;
  
  const fileUpload = async (e) => {
    const { files } = e.target
    const validImageFiles = []
    for (let i = 0; i < files.length; i++) {
      const file = files[i]
      console.log(file)
      if (file.type.match(imageTypeRegex)) {
        validImageFiles.push(file);
      }
    }
    if (validImageFiles.length) {
      setImageFiles([...imageFiles, ...validImageFiles])
      getBase64(validImageFiles)
      await delay(100)
      scrollTo(isMobile ? "imageList" : "uploadImage")
      return;
    } else {
      setError('Filtypen skal være PNG, JPG eller JPEG')
    }
  }

  const getBase64 = (files) => {
    const img = [], fileReaders = [];
    let isCancel = false;
    if (files.length) {
      files.map((file, index) => {
        const fileReader = new FileReader();
        fileReaders.push(fileReader);
        fileReader.onload = (e) => {
          const { result } = e.target;
          if (result) {
            img[index] = result
          }
          if (img.length === files.length && !isCancel) {
            setImages([...images, ...img]);
          }
        }
        fileReader.readAsDataURL(file);
      })
    };
    return () => {
      isCancel = true;
      fileReaders.forEach(fileReader => {
        if (fileReader.readyState === 1) {
          fileReader.abort()
        }
      })
    }
  }

  const primaryImage = (index) => {
    const newList = [...imageFiles]
    const newImages = [...images]
    if (imageFiles.length > 1) {
      if (index > -1) {
        newList.splice(index, 1)
        newList.unshift(imageFiles[index])
        setImageFiles(newList)
        newImages.splice(index, 1)
        newImages.unshift(images[index])
        setImages(newImages)
      }
    }
  }

  const deleteImage = (index) => {
    const newList = [...imageFiles]
    const newImages = [...images]
    if (imageFiles.length <= 1) {
      setImageFiles([])
      setImages([])
    } else if (index > -1) {
      newList.splice(index, 1)
      setImageFiles(newList)
      newImages.splice(index, 1)
      setImages(newImages)
    }
  }
  
  useEffect(() => {
    setSessionId(uuidv4())
    socket.on('image', (data) => {
      const file = base64ToFile(data, `upload-${Date.now()}.jpg`);
      setImageFiles((prev) => [...prev, file])
      setImages((prev) => [...prev, data])
      scrollTo(isMobile ? "imageList" : "uploadImage")
    })
    
    return () => {
      socket.off('image');
    };
  }, [])
    useEffect(() => {
      if (sessionId !== '') {
        socket.emit('join_session', sessionId);
        console.log(sessionId)
      }
      
      return () => {
        if (sessionId !== '') {
          socket.emit('leave_session', sessionId);
        }
      };
    }, [socket, sessionId]);
  
  // Konverter Base64 til en File
  function base64ToFile(base64, filename) {
    const arr = base64.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  return (
    <div className="bookInfo gap-6 w-full h-full relative flex-[1] flex flex-col" id="uploadImage">
      <div className="flex flex-col md:flex-row gap-6">
        <div className="flex flex-col gap-6 md:text-nowrap">
          <h2 className="text-left w-full block text-sm font-medium text-gray-900">Upload et billede</h2>
          {(error !== '') ? <h2 className="text-left w-full text-sm font-medium text-gray-900 text-red-500">{error}</h2> : ""}
          <div className="flex gap-4">
            <div className="flex flex-col w-full h-full">
                <label for="dropzone-file" className="w-full text-center md:w-fit text-white bg-gradient-to-r from-emerald-600 to-emerald-700 px-4 py-2 bg-size-200 bg-pos-0 hover:bg-pos-100 transition-[] cursor-pointer">
                  <p className="text-sm">Tilføj et billede</p>
                </label>
                <input id="dropzone-file" type="file" accept="image/apng, image/avif, image/jpeg, image/png, image/svg+xml, image/webp" multiple className="hidden" onClick={() => setError('')} onChange={fileUpload} />
            </div>
          </div>
        </div>
        <div className="hidden md:flex gap-4 items-center p-4 ring-1 ring-emerald-400 w-full">
          <QRCodeCanvas value={`http://bogbanken.dk/uploadImage?sessionId=${sessionId}`} size={100} />
          <h2 className="text-left w-full block text-sm font-medium text-gray-900">Scan QR-koden for at tage et billede med mobilen</h2>
        </div>
      </div>
      {(imageFiles.length > 0) ?
        <div className="imageList flex flex-col sm:flex-row gap-5" id="imageList">
          <div className="primaryImage flex flex-col-reverse sm:flex-col gap-2 w-full h-full sm:w-72">
            <div className="h-fit aspect-square sm:h-72 w-full sm:w-72 p-1 border-4 border-emerald-600">
              {(images.length > 0) ? <img src={images[0]} alt="" className="object-contain w-full h-full select-none" /> : <LoadingFull />}
            </div>
            <div className="w-full">
              <h2 className="font-medium">Primært billede</h2>
              <p className="text-sm">Dette billede vises i søgeresultaterne</p>
            </div>
          </div>
          <div className="smallImages grid grid-cols-3 sm:grid-cols-2 md:grid-cols-3 gap-2 h-fit md:w-max">
            {imageFiles.map((imageFile, index) => {
              return (
                <div className={"relative aspect-square w-full h-full transition-[] cursor-pointer group" + (index === 0 ? "" : " border border-neutral-200 hover:border-emerald-600")}>
                  <div className={"h-full w-full p-1" + (index === 0 ? " bg-emerald-600" : "")} onClick={() => primaryImage(index)}>
                    {(images.length > index) ? <img src={images[index]} alt="" className="bg-white p-1 object-contain w-full h-full pointer-none select-none" /> : <LoadingFull />}
                  </div>
                  <div className="absolute right-2 top-2 text-xl hidden group-hover:block bg-orange-500 text-white transition-[] p-1" onClick={() => deleteImage(index)}><RxCross2 /></div>
                </div>
              )
            })}
          </div>
        </div>
      :
        ""
      }
    </div>
  )
}